import React from 'react';
import { translate } from '../locale';
import Text from './Text';

export default function LocaleText({ language = 'de', keyName, value }) {
  return (
    <span>{translate(language, keyName, value)}</span>
  );
}